// GrowSureHome.jsx
import React, { useState } from "react";

const GrowSureHome = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userName, setUserName] = useState("Guest");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showRoles, setShowRoles] = useState(false);

  const features = [
    { emoji: "🌱", title: "Root-Cause Transformation", desc: "Empowering PMMY micro-enterprises with AI-driven Kaizen for sustainable growth." },
    { emoji: "🤝", title: "Trust & Accountability", desc: "Enhancing transparency in loan processing and monitoring for MLIs and borrowers." },
    { emoji: "📊", title: "Data Insights", desc: "Leverage analytics to address fraud, delays, and scaling challenges." },
    { emoji: "🚚", title: "Efficient Support", desc: "Streamlined post-disbursement support to maximize outcomes." },
    { emoji: "💡", title: "Innovative Tools", desc: "5 Whys diagnostics, dashboards, and workshops for continuous improvement." },
    { emoji: "🌍", title: "Inclusive Impact", desc: "Strengthening India’s micro-enterprise ecosystem with scalable solutions." }
  ];

  const roles = [
    "🏭 Government Official",
    "📍 MLI Coordinator",
    "🔗 Bank Officer",
    "⚙️ Micro-Entrepreneur",
    "🏆 Think5Whys Facilitator",
    "👷‍♂️ Field Auditor",
    "📦 Loan Processor",
    "🏬 Regional Manager",
    "🛒 Tarun+ Borrower",
    "🚚 Compliance Officer",
    "📦 Monitoring Specialist",
    "🌐 Policy Maker",
    "🛠️ Training Consultant",
    "🔧 Fraud Analyst",
    "🤝 NGO Partner",
    "🏢 Enterprise Advisor",
    "📚 Research Analyst",
    "🤖 AI Implementation Expert",
    "🧑‍🔬 Process Optimizer",
    "📊 Quality Assessor"
  ];

  const handleNavigate = (role) => {
    alert(`Navigating to enrollment for ${role} at 01:45 PM IST, September 28, 2025`);
  };

  return (
    <div className="font-sans text-gray-800 bg-gray-100 [&_p]:text-white [&_li]:text-white">
      {/* Header */}
      <header className="flex justify-between items-center px-6 py-2 bg-teal-700 shadow-md sticky top-0 z-50">
        <div className="text-2xl font-extrabold text-white tracking-wide">GrowSure</div>

        {/* Desktop Menu */}
        <nav className="hidden md:flex space-x-6 font-medium text-white">
          <a href="#whyus" className="hover:text-yellow-200 transition">About</a>
          <a href="#pmmy" className="hover:text-yellow-200 transition">PMMY</a>
          <a href="#gapsinpmmy" className="hover:text-yellow-200 transition">PMMY Gaps</a>
          <a href="#cases" className="hover:text-yellow-200 transition">Cases</a>
        </nav>

        <div className="hidden md:flex items-center space-x-4">
          {isLoggedIn ? (
            <>
              <span className="text-white font-medium">Welcome, {userName}</span>
              <button
                onClick={() => alert('Dashboard opened')}
                className="w-9 h-9 flex items-center justify-center text-lg bg-teal-500 text-white rounded-lg hover:bg-teal-600 transition"
                title="Dashboard"
              >
                🏠
              </button>
              <button
                onClick={() => setIsLoggedIn(false)}
                className="w-9 h-9 flex items-center justify-center text-lg bg-red-500 text-white rounded-full hover:bg-red-600 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => alert('Login page opened')}
                className="px-4 py-2 text-sm border border-white text-white rounded-full hover:bg-teal-50 hover:text-teal-700 transition"
              >
                Login
              </button>
              <button
                onClick={() => alert('Signup page opened')}
                className="px-4 py-2 text-sm bg-white text-teal-700 rounded-full hover:bg-teal-100 transition"
              >
                Register
              </button>
            </>
          )}
        </div>

        {/* Mobile Hamburger */}
        <div className="md:hidden flex items-center justify-center w-24">
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="text-3xl text-white focus:outline-none"
            aria-label="Toggle Menu"
          >
            {isMobileMenuOpen ? "×" : "☰"}
          </button>
        </div>
      </header>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white px-6 py-4 space-y-1 text-center shadow-md">
          {isLoggedIn && (
            <div className="flex flex-col items-center text-gray-800">
              <p className="text-teal-600 font-medium">{userName}</p>
              <div className="flex space-x-4 mt-2">
                <button
                  onClick={() => alert('Dashboard opened')}
                  className="w-10 h-10 flex items-center justify-center text-lg bg-teal-500 text-white rounded-full hover:bg-teal-600 transition"
                >
                  🏠
                </button>
                <button
                  onClick={() => setIsLoggedIn(false)}
                  className="w-10 h-10 flex items-center justify-center text-lg bg-red-500 text-white rounded-full hover:bg-red-600 transition"
                >
                  ⏻
                </button>
              </div>
            </div>
          )}
          <a href="#whyus" className="block hover:text-teal-600">About</a>
          <a href="#pmmy" className="block hover:text-teal-600">PMMY</a>
          <a href="#gapsinpmmy" className="block hover:text-teal-600">Gaps in PMMY</a>
          <a href="#cases" className="block hover:text-teal-600">Cases</a>

          {!isLoggedIn && (
            <div className="flex justify-center space-x-4 pt-2">
              <button className="px-4 py-2 text-sm border border-teal-500 text-teal-600 rounded-full hover:bg-teal-50 transition">Login</button>
              <button className="px-4 py-2 text-sm bg-teal-600 text-white rounded-full hover:bg-teal-700 transition">Register</button>
            </div>
          )}
        </div>
      )}

      {/* Hero Section */}
      <section
        className="relative min-h-[60vh] sm:min-h-[70vh] bg-cover bg-center flex items-center justify-center text-white"
        style={{ backgroundImage: "url('/assets/banners/growsure-bg.jpg')" }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-60"></div>
        <div className="relative z-10 px-4 sm:px-6 md:px-10 lg:px-16 py-4 w-full max-w-6xl mx-auto">
          <h1 className="text-lg lg:text-xl font-bold text-center mb-2 text-yellow-200">
            GrowSure with Think5Whys Transformation-as-a-Platform
          </h1>
          <p className="text-xs lg:text-sm text-center text-white mb-2 font-medium">
            Empowering PMMY Micro-Enterprises - Shishu → Kishore → Tarun → Tarun+ 
          </p>
          {/* <div className="flex flex-col items-center justify-center bg-teal-900/90 py-2 px-4 shadow-lg rounded-2xl mb-2">
            <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-2 w-full">
              <a href="#tools" className="hover:text-yellow-200 transition text-center sm:text-left w-full sm:w-auto">
                💻 5 Whys Diagnostic Kit
              </a>
              <a href="#workshop" className="hover:text-yellow-200 transition text-center sm:text-left w-full sm:w-auto">
                💡 Fraud Prevention Workshop
              </a>
              <a href="#cases" className="hover:text-yellow-200 transition text-center sm:text-left w-full sm:w-auto">
                🪪 Mock Case Studies
              </a>
            </div>
          </div> */}
          <div className="bg-teal-900/90 py-4 px-6 shadow-lg rounded-2xl mb-4">
            <div className="grid grid-cols-2 lg:grid-cols-6 gap-4">
                <a href="#pmmy" className="bg-teal-700 hover:bg-yellow-600 text-white font-semibold py-3 px-4 rounded-lg text-center transition">
                📚 Owner's Key Literacy
                </a>
                <a href="#shishu" className="bg-teal-700 hover:bg-yellow-600 text-white font-semibold py-3 px-4 rounded-lg text-center transition">
                🧸 Shishu Ranking
                </a>
                <a href="#kishore" className="bg-teal-700 hover:bg-yellow-600 text-white font-semibold py-3 px-4 rounded-lg text-center transition">
                🏆 Kishore Ranking
                </a>
                <a href="#tarun" className="bg-teal-700 hover:bg-yellow-600 text-white font-semibold py-3 px-4 rounded-lg text-center transition">
                🚀 Tarun Ranking
                </a>
                <a href="#tarunplus" className="bg-teal-700 hover:bg-yellow-600 text-white font-semibold py-3 px-4 rounded-lg text-center transition">
                🌟 Tarun+ Ranking
                </a>
                <a href="#ownerkit" className="bg-teal-700 hover:bg-yellow-600 text-white font-semibold py-3 px-4 rounded-lg text-center transition">
                🧰 Owner Kit
                </a>
                <a href="#rcatool" className="bg-teal-700 hover:bg-yellow-600 text-white font-semibold py-3 px-4 rounded-lg text-center transition">
                🛠️ RCA Tool
                </a>
                <a href="#chronicles" className="bg-teal-700 hover:bg-yellow-600 text-white font-semibold py-3 px-4 rounded-lg text-center transition">
                📖 Business Chronicles
                </a>
                <a href="#reward" className="bg-teal-700 hover:bg-yellow-600 text-white font-semibold py-3 px-4 rounded-lg text-center transition">
                🎁 Reward
                </a>
                <a href="#certificates" className="bg-teal-700 hover:bg-yellow-600 text-white font-semibold py-3 px-4 rounded-lg text-center transition">
                🏅 Certificates
                </a>
                <a href="#digitalcard" className="bg-teal-700 hover:bg-yellow-600 text-white font-semibold py-3 px-4 rounded-lg text-center transition">
                💳 Digital Business Card
                </a>
                <a href="#aicounselling" className="bg-teal-700 hover:bg-yellow-600 text-white font-semibold py-3 px-4 rounded-lg text-center transition">
                🤖 AI Counselling
                </a>
                <a href="#marketplace" className="bg-teal-700 hover:bg-yellow-600 text-white font-semibold py-3 px-4 rounded-lg text-center transition">
                🏭 Manufacturer Marketplace
                </a>
                <a href="#marketplace" className="bg-teal-700 hover:bg-yellow-600 text-white font-semibold py-3 px-4 rounded-lg text-center transition">
                🌾 Agri Marketplace
                </a>
                <a href="#marketplace" className="bg-teal-700 hover:bg-yellow-600 text-white font-semibold py-3 px-4 rounded-lg text-center transition">
                🛒 Udyam Marketplace
                </a>                
            </div>
            </div>

          <div className="text-center mb-2">
            <button
              onClick={() => setShowRoles(!showRoles)}
              className="bg-teal-700 text-white hover:bg-teal-600 px-6 py-2 rounded-full font-semibold shadow"
            >
              <span className="text-white">👤</span> Enroll As {showRoles ? "▲" : "▼"}
            </button>
          </div>
          {showRoles && (
            <div className="grid grid-cols-[repeat(auto-fit,minmax(140px,1fr))] gap-2 mb-4">
              {roles.map((role, idx) => (
                <button
                  key={idx}
                  onClick={() => handleNavigate(role)}
                  className="bg-teal-800 text-white hover:bg-teal-700 transition rounded-md py-1 px-2 text-sm text-center shadow"
                >
                  {role}
                </button>
              ))}
            </div>
          )}
        </div>
      </section>

    {/* PMMY Section */}
    <section id="pmmy" className="py-4 px-6 md:px-20 bg-teal-800 text-white">
      <h2 className="text-yellow-200 text-lg lg:text-xl font-bold text-center mb-6">Pradhan Mantri MUDRA Yojana (PMMY)</h2>
      <div className="max-w-6xl mx-auto space-y-8">
        {/* What is PMMY? */}
        <div className="bg-white/10 p-6 rounded-xl shadow-lg backdrop-blur-lg hover:bg-white/20 transition">
          <h3 className="text-lg font-semibold mb-3 text-cyan-200">What is PMMY?</h3>
          <p className="text-sm leading-relaxed">
            Pradhan Mantri MUDRA Yojana (PMMY) is India’s flagship micro-credit programme, launched on 8 April 2015, to provide collateral-free institutional credit to non-corporate, non-farm micro and small enterprises (manufacturing, trading, services, and allied activities). The implementing entity is MUDRA (Micro Units Development & Refinance Agency Ltd), with lending facilitated by banks, Regional Rural Banks (RRBs), Small Finance Banks (SFBs), Non-Banking Finance Companies (NBFCs), and Microfinance Institutions (MFIs).
          </p>
        </div>

        {/* Categories & Loan Limits */}
        <div className="bg-white/10 p-6 rounded-xl shadow-lg backdrop-blur-lg hover:bg-white/20 transition">
          <h3 className="text-lg font-semibold mb-3 text-cyan-200">Categories & Loan Limits</h3>
          <p className="text-sm leading-relaxed">
            PMMY is lifecycle-based with four categories:
          </p>
          <ul className="list-disc list-inside text-sm space-y-2 mt-2">
            <li><strong>Shishu</strong> — up to ₹50,000</li>
            <li><strong>Kishore</strong> — above ₹50,000 and up to ₹5,00,000</li>
            <li><strong>Tarun</strong> — above ₹5,00,000 and up to ₹10,00,000</li>
            <li><strong>Tarun Plus</strong> — ₹10,00,001 up to ₹20,00,000 (added July 2024; implemented Oct 2024)</li>
          </ul>
          <p className="text-sm mt-2">Loans are collateral-free and available via Member Lending Institutions (MLIs). Interest rates and tenors depend on the lender.</p>
          <p className="text-xs italic mt-1">Note: MLI = Member Lending Institution (banks, NBFCs, MFIs, etc., signed with MUDRA Ltd).</p>
        </div>

        {/* Types of MLIs */}
        <div className="bg-white/10 p-6 rounded-xl shadow-lg backdrop-blur-lg hover:bg-white/20 transition">
          <h3 className="text-lg font-semibold mb-3 text-cyan-200">Types of MLIs</h3>
          <ul className="grid grid-cols-2 gap-2 text-sm">
            <li>Public Sector Banks (PSBs)</li>
            <li>Private Sector Banks</li>
            <li>Regional Rural Banks (RRBs)</li>
            <li>Small Finance Banks (SFBs)</li>
            <li>Microfinance Institutions (MFIs)</li>
            <li>Non-Banking Finance Companies (NBFCs)</li>
          </ul>
        </div>

        {/* Role of MLIs in PMMY */}
        <div className="bg-white/10 p-6 rounded-xl shadow-lg backdrop-blur-lg hover:bg-white/20 transition">
          <h3 className="text-lg font-semibold mb-3 text-cyan-200">Role of MLIs in PMMY</h3>
          <ul className="list-disc list-inside text-sm space-y-2">
            <li>Disburse Mudra loans (Shishu, Kishore, Tarun) to micro/small borrowers.</li>
            <li>Follow due diligence, verification, and reporting guidelines.</li>
            <li>Report loan performance back to MUDRA/GoI for refinancing and impact tracking.</li>
          </ul>
        </div>

        {/* How to Get the Loan? */}
        <div className="bg-white/10 p-6 rounded-xl shadow-lg backdrop-blur-lg hover:bg-white/20 transition">
          <h3 className="text-lg font-semibold mb-3 text-cyan-200">How to Get the Loan?</h3>
          <p className="text-sm leading-relaxed">
            Apply at a local bank branch, RRB, NBFC, MFI, or Small Finance Bank, or online via government-supported platforms (e.g., PSBloansin59minutes, Udyamimitra) and the MUDRA MITRA mobile app. Lenders also offer a “Mudra Card” (RuPay overdraft style) for working capital.
          </p>
          <p className="text-sm font-medium mt-2">Typical Steps:</p>
          <ol className="list-decimal list-inside text-sm space-y-2 mt-1">
            <li>Decide category & amount (Shishu → Tarun Plus).</li>
            <li>Gather documents: ID, address, KYC, bank statements (last 6 months), proof of business existence/ownership, quotations or project/purchase invoices for higher loans; some lenders may request a business plan for larger amounts (exact docs vary by lender).</li>
            <li>Apply at a branch or via the portal/mobile app → lender conducts credit assessment/KYC → sanction & disbursement.</li>
            <li>Use Mudra Card or account overdraft as applicable; lenders may offer hand-holding support.</li>
          </ol>
          <p className="text-xs italic mt-2">Note: Interest rate, processing fee, and collateral requirements (if any) are set by the lending institution—PMMY does not fix interest rates.</p>
        </div>

        {/* Benefits */}
        <div className="bg-white/10 p-6 rounded-xl shadow-lg backdrop-blur-lg hover:bg-white/20 transition">
          <h3 className="text-lg font-semibold mb-3 text-cyan-200">Benefits (Why It Matters)</h3>
          <ul className="list-disc list-inside text-sm space-y-2">
            <li>Access to formal credit for those previously excluded—reduces dependence on informal moneylenders.</li>
            <li>Collateral-free borrowing for micro enterprises.</li>
            <li>Scale & inclusion: strong outreach to women, SC/ST/OBC, and minority borrowers; special schemes like 2% interest subvention on prompt repayment for eligible Shishu borrowers (for 12 months) were announced earlier.</li>
            <li>Products & digital tools: Mudra Card, Mudra Mitra app, online submission routes reduce friction.</li>
            <li>Economic impact: supports self-employment and small-scale growth (jobs, local livelihoods).</li>
          </ul>
        </div>

        {/* Effectiveness — What the Data Shows */}
        <div className="bg-white/10 p-6 rounded-xl shadow-lg backdrop-blur-lg hover:bg-white/20 transition">
          <h3 className="text-lg font-semibold mb-3 text-cyan-200">Effectiveness — What the Data Shows</h3>
          <ul className="list-disc list-inside text-sm space-y-2">
            <li><strong>Scale:</strong> As of 28 Feb 2025, PMMY has facilitated over 52 crore (520+ million) loan accounts since launch (2015). Rising average ticket sizes and a shift from ultra-small (Shishu) to larger categories over time.</li>
            <li><strong>FY 2023-24 Performance:</strong> ~₹5.41 lakh crore sanctioned and ₹5.32 lakh crore disbursed in ~6.68 crore loan accounts (MUDRA Annual Report).</li>
            <li><strong>NITI Aayog Assessment:</strong> An official impact assessment (KPMG for NITI) found PMMY reached tens of crores of borrower accounts and increased credit access, but flagged structural gaps with granular findings on category-wise shares, sectoral reach, and areas needing improvement.</li>
          </ul>
        </div>

        {/* How Many Have Benefited? */}
        <div className="bg-white/10 p-6 rounded-xl shadow-lg backdrop-blur-lg hover:bg-white/20 transition">
          <h3 className="text-lg font-semibold mb-3 text-cyan-200">How Many Have Benefited?</h3>
          <ul className="list-disc list-inside text-sm space-y-2">
            <li>As of 28 Feb 2025: >52 crore loan accounts sanctioned since launch (8 Apr 2015 to 28 Feb 2025) (PIB release, 7 Apr 2025).</li>
            <li>FY 2023-24 alone: about 6.68 crore loan accounts and ~₹5.32 lakh crore disbursed (MUDRA Annual Report).</li>
            <li>Earlier NITI (Nov 2023) snapshot: ~34.9 crore accounts and ~₹18.39 lakh crore in credit by that time (reporting period differs).</li>
          </ul>
          <p className="text-sm mt-2">Bottom line: PMMY is large and has materially advanced financial inclusion, but outcomes (business growth, durable incomes, NPAs) vary by region, lender, and borrower profile.</p>
        </div>
      </div>
    </section>

    {/* Gaps in PMMY Section */}
    <section id="gapsinpmmy" className="py-12 px-6 md:px-20 bg-teal-800 text-white">
      <h2 className="text-2xl font-bold text-center mb-6 text-yellow-200">What’s Not Working Well in PMMY</h2>
      <div className="max-w-6xl mx-auto space-y-8">
        {/* Gaps / Persistent Problems */}
        <div className="bg-white/10 p-6 rounded-xl shadow-lg backdrop-blur-lg hover:bg-white/20 transition">
          <h3 className="text-lg font-semibold mb-3 text-cyan-200">Gaps / Persistent Problems</h3>
          <p className="text-sm leading-relaxed mb-3">
            Key gaps identified by official assessments, academic studies, and media reporting:
          </p>
          <ul className="list-disc list-inside text-sm space-y-2">
            <li>Concentration at the smallest ticket size: A large share of accounts historically sit in the Shishu category (many very small loans), which limits scaling impact unless borrowers return for larger loans. (NITI/KPMG findings.)</li>
            <li>Loan misuse / fraud risk & weak verification: Isolated but material fraud cases reported (fake companies, forged documents), producing NPAs and losses for banks. The media has documented such cases.</li>
            <li>Implementation frictions: Long processing time at some MLIs, high processing fees or interest (varies by lender), inconsistent documentation requirements, and patchy hand-holding after disbursement.</li>
            <li>Limited post-loan support / market linkages: Credit alone doesn't guarantee growth — many micro firms need mentoring, market access, bookkeeping, digital payments onboarding, etc.</li>
            <li>Monitoring / M&E gaps: Inconsistent borrower tracking, limited standardized impact metrics (e.g., how many borrowers grew revenues or created sustained jobs). NITI recommends better data, eKYC usage, and institutional monitoring.</li>
          </ul>
        </div>

        {/* How Think5Whys Can Fill the Gap */}
        <div className="bg-white/10 p-6 rounded-xl shadow-lg backdrop-blur-lg hover:bg-white/20 transition">
          <h3 className="text-lg font-semibold mb-3 text-cyan-200">How Think5Whys Can Fill the Gap — Practical, Mapped Actions</h3>
          <p className="text-sm leading-relaxed mb-3">
            Think5Whys positions itself under a new category i.e. Transformation-as-a-Platform (having an array of tools for all stakeholders starting with root-cause 5 Whys) — is an ideal fit.
          </p>
          <p className="text-sm leading-relaxed mb-3">
            Below are common PMMY gaps mapped to concrete Think5Whys interventions that can be delivered as offerings or pilots:
          </p>
          <ul className="list-disc list-inside text-sm space-y-2">
            <li>Reduce fraud & ensure genuine use of funds</li>
            <li>Speed up loan processing & cut bottlenecks</li>
            <li>Moving borrowers from Shishu → Kishore → Tarun (scaling)</li>
            <li>Improve post-disbursement outcomes (handholding)</li>
            <li>Strengthen monitoring & outcome metrics</li>
          </ul>
        </div>

        {/* A. Reduce Fraud & Ensure Genuine Use of Funds */}
        <div className="bg-white/10 p-6 rounded-xl shadow-lg backdrop-blur-lg hover:bg-white/20 transition">
          <h3 className="text-lg font-semibold mb-3 text-cyan-200">A. Reduce Fraud & Ensure Genuine Use of Funds</h3>
          <p className="text-sm font-medium mb-2">Problem: Fake docs, ghost beneficiaries, forged invoices.</p>
          <p className="text-sm font-medium mb-2">Think5Whys Solution:</p>
          <ul className="list-disc list-inside text-sm space-y-2">
            <li>Running a 5-Whys root cause drill for every fraud instance (or sample of defaults) to identify breakdowns (e.g., who verified documents → why verification was weak → why staff incentivized to push volumes → why spot checks were absent).</li>
            <li>Building a Verification Checklist + 5-Why Template for branch officers (KYC flags, supplier invoice validation, physical site verification triggers).</li>
            <li>Delivering training + a short field-audit playbook for “spot verification” and a simple scoring rule that flags suspicious cases for escalation.</li>
          </ul>
          <p className="text-sm mt-2">Output: A 1-page “Fraud Red Flags + 5-Whys Remedial Steps” card for bank officers and BCs.</p>
        </div>

        {/* B. Speed Up Loan Processing & Cut Bottlenecks */}
        <div className="bg-white/10 p-6 rounded-xl shadow-lg backdrop-blur-lg hover:bg-white/20 transition">
          <h3 className="text-lg font-semibold mb-3 text-cyan-200">B. Speed Up Loan Processing & Cut Bottlenecks</h3>
          <p className="text-sm font-medium mb-2">Problem: Delays due to manual forms, multiple touchpoints.</p>
          <p className="text-sm font-medium mb-2">Think5Whys Solution:</p>
          <ul className="list-disc list-inside text-sm space-y-2">
            <li>Facilitating a process-mapping workshop through Think5Whys Boutique Auditors at a bank branch using 5 Whys to find the root cause of delays (e.g., document mismatch → physical signatures → back-and-forth → manual data entry).</li>
            <li>Recommending quick fixes: pre-filled common fields, digital eKYC triggers, single-window checklist, nominated MUDRA nodal officer, SLAs and a simple dashboard (turnaround times per stage).</li>
            <li>Providing a 2-week pilot checklist and a template for an automated “pre-submission completeness” checklist.</li>
          </ul>
          <p className="text-sm mt-2">Output: Process map + 3 low-cost tech/process fixes; expected TAT reduction metrics to track.</p>
        </div>

        {/* C. Moving Borrowers from Shishu → Kishore → Tarun (Scaling) */}
        <div className="bg-white/10 p-6 rounded-xl shadow-lg backdrop-blur-lg hover:bg-white/20 transition">
          <h3 className="text-lg font-semibold mb-3 text-cyan-200">C. Moving Borrowers from Shishu → Kishore → Tarun (Scaling)</h3>
          <p className="text-sm font-medium mb-2">Problem: Many borrowers stay in micro brackets, not scaling.</p>
          <p className="text-sm font-medium mb-2">Think5Whys Solution:</p>
          <ul className="list-disc list-inside text-sm space-y-2">
            <li>Using 5 Whys with cohorts (e.g., Shishu borrowers in the last 2 years) to find why they didn’t take larger loans: market demand? accounting? confidence? lack of growth plan?</li>
            <li>Designing “Growth Roadmap” micro-module: bookkeeping basics, simple unit-economics, monthly targets, cashflow clinic, access to buyer linkages.</li>
            <li>Tying growth roadmap completion to a “fast-track” assessment that speeds up future Kishore/Tarun approvals.</li>
          </ul>
          <p className="text-sm mt-2">Output: 4-session bootcamp + mentor connect + KPI dashboard to demonstrate income/turnover improvements.</p>
        </div>

        {/* D. Improve Post-Disbursement Outcomes (Handholding) */}
        <div className="bg-white/10 p-6 rounded-xl shadow-lg backdrop-blur-lg hover:bg-white/20 transition">
          <h3 className="text-lg font-semibold mb-3 text-cyan-200">D. Improve Post-Disbursement Outcomes (Handholding)</h3>
          <p className="text-sm font-medium mb-2">Problem: Credit without ongoing support leads to high stress/default.</p>
          <p className="text-sm font-medium mb-2">Think5Whys Solution:</p>
          <ul className="list-disc list-inside text-sm space-y-2">
            <li>5-Why analysis and other micro six sigma tools of early default cases to identify leading indicators (missed collections, supplier issues, seasonality).</li>
            <li>Creating Early-Warning Checklists and a simple monthly “health check” mobile form filled by BCs/agents, prompting remedial support (cashflow advice, market linkages).</li>
            <li>Offer community peer groups (village/urban clusters) moderated via Think5Whys facilitators to share solutions.</li>
          </ul>
          <p className="text-sm mt-2">Output: 6-month support playbook + mobile checklist + cohort learning circles.</p>
        </div>

        {/* E. Strengthen Monitoring & Outcome Metrics */}
        <div className="bg-white/10 p-6 rounded-xl shadow-lg backdrop-blur-lg hover:bg-white/20 transition">
          <h3 className="text-lg font-semibold mb-3 text-cyan-200">E. Strengthen Monitoring & Outcome Metrics</h3>
          <p className="text-sm font-medium mb-2">Problem: Weak M&E and inconsistent impact metrics.</p>
          <p className="text-sm font-medium mb-2">Think5Whys Solution:</p>
          <ul className="list-disc list-inside text-sm space-y-2">
            <li>Defining a small set of actionable KPIs (NPA rate, % repeat borrowing, % increment in turnover at 6/12 months, % women borrowers sustaining business) and map data sources.</li>
            <li>Using 5 Whys to investigate measurement gaps and design a low-effort data collection cadence (quarterly short surveys + branch reports).</li>
            <li>Building a short training + template dashboard so branches and MUDRA nodal officers can report cleanly.</li>
          </ul>
          <p className="text-sm mt-2">Output: KPI matrix + 1-page M&E SOP + dashboard template.</p>
        </div>

        {/* Note on M&E */}
        <div className="bg-white/10 p-6 rounded-xl shadow-lg backdrop-blur-lg hover:bg-white/20 transition">
          <h3 className="text-lg font-semibold mb-3 text-cyan-200">Note: M&E Stands for Monitoring & Evaluation</h3>
          <ul className="list-disc list-inside text-sm space-y-2">
            <li><strong>Monitoring (M)</strong> → Continuous tracking of activities, inputs, outputs (e.g., how many loans disbursed, repayment schedules, number of women/SC/ST beneficiaries).</li>
            <li><strong>Evaluation (E)</strong> → Periodic assessment of outcomes and impact (e.g., whether loans actually created jobs, improved income, reduced poverty, built sustainable businesses).</li>
          </ul>
          <p className="text-sm font-medium mt-4 mb-2">Why We Call It a “Weak M&E” Here:</p>
          <ul className="list-disc list-inside text-sm space-y-2">
            <li>Data collected is often quantity-focused (loans sanctioned, disbursed) instead of quality-focused (business survival, income stability, job creation).</li>
            <li>Metrics are inconsistent across states/banks → making national comparisons unreliable.</li>
            <li>Borrower follow-up is minimal, so the “impact chain” (loan → enterprise → jobs/income) is not fully tracked.</li>
          </ul>
          <p className="text-sm mt-2">In simple terms, Weak M&E means: We know how much money went out, but we don’t really know how much good it actually did.</p>
          <p className="text-sm mt-2">Think5Whys GrowSure ecosystem could directly plug this gap by offering Impact M&E Rankings → linking loan data with borrower outcomes (growth %, jobs, repayment, continuous owner literacy, continuous process capability & maturity, innovation) in a transparent dashboard.</p>
        </div>
      </div>
    </section>

    

      {/* Why Choose GrowSure */}
      <section id="whyus" className="py-6 px-6 md:px-20 bg-gradient-to-r from-teal-600 to-teal-700">
        <h2 className="text-yellow-200 text-2xl font-bold text-center mb-4">Why Choose GrowSure?</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 text-center text-white">
          {features.map((feature, idx) => (
            <div key={idx} className="bg-white/10 p-4 rounded-xl shadow-lg backdrop-blur-lg hover:bg-white/20 transition">
              <div className="text-3xl mb-3">{feature.emoji}</div>
              <h4 className="text-lg font-semibold mb-2 text-gray-100">{feature.title}</h4>
              <p className="text-sm text-gray-200">{feature.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Tools Section */}
      <section id="tools" className="py-8 px-6 md:px-20 bg-teal-800 text-white">
        <h2 className="text-yellow-200 text-xl font-bold text-center mb-2">GrowSure Tools</h2>
        <div className="max-w-6xl mx-auto space-y-4">
          <div className="bg-white/10 p-2 rounded-xl shadow-lg backdrop-blur-lg hover:bg-white/20 transition">
            <h3 className="text-m font-semibold mb-1 text-cyan-200">✨ Key Deliverables</h3>
            <ul className="list-disc list-inside text-sm space-y-1">
              <li><strong>📋 Fraud Checklist</strong> — Identify red flags in loan applications.</li>
              <li><strong>📊 Dashboards</strong> — Monitor PMMY outcomes in real-time.</li>
              <li><strong>📚 SOPs</strong> — Standardized processes for MLIs.</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Workshop Section */}
      <section id="workshop" className="py-8 px-6 md:px-20 bg-teal-700 text-white">
        <h2 className="text-yellow-200 text-xl font-bold text-center mb-2">2-Hour Fraud Prevention Workshop</h2>
        <div className="max-w-6xl mx-auto space-y-4">
          <div className="bg-white/10 p-2 rounded-xl shadow-lg backdrop-blur-lg hover:bg-white/20 transition">
            <h3 className="text-m font-semibold mb-1 text-cyan-200">✨ Agenda</h3>
            <ul className="list-disc list-inside text-sm space-y-1">
              <li><strong>📅 Welcome</strong> — Introduction to GrowSure.</li>
              <li><strong>🛠️ Group Activity</strong> — 5 Whys practice.</li>
              <li><strong>📜 Action Plans</strong> — Develop branch strategies.</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Mock Cases Section */}
      <section id="cases" className="py-8 px-6 md:px-20 bg-teal-800 text-white">
        <h2 className="text-yellow-200 text-xl font-bold text-center mb-2">Mock Case Studies</h2>
        <div className="max-w-6xl mx-auto space-y-4">
          <div className="bg-white/10 p-2 rounded-xl shadow-lg backdrop-blur-lg hover:bg-white/20 transition">
            <h3 className="text-m font-semibold mb-1 text-cyan-200">✨ Examples</h3>
            <ul className="list-disc list-inside text-sm space-y-1">
              <li><strong>📊 Cash Spike Case</strong> — Detect anomalies in Shishu loans.</li>
              <li><strong>🔍 Ghost Supplier</strong> — Resolve Kishore loan fraud.</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-teal-700 text-white py-10 px-4 sm:px-6 md:px-20">
        <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left">
          <p className="text-sm">&copy; 2025 Think5Whys Global DeepTech Solutions. All rights reserved.</p>
          <div className="flex space-x-6 mt-4 md:mt-0 text-sm">
            <a href="#about" className="text-white hover:text-yellow-200 transition">About</a>
            <a href="#privacy" className="text-white hover:text-yellow-200 transition">Privacy</a>
            <a href="#contact" className="text-white hover:text-yellow-200 transition">Contact</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default GrowSureHome;